export const setPageData = 'setPageData'
export const setPagination = 'setPagination'



// WEBPACK FOOTER //
// ./src/app/components/shareds/pagination/vuex/mutations-types.js